module.exports = __webpack_public_path__ + "img/icn_transportation3.0566221a.png";